import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AddressService } from '../../services/address.service';
import { StateService } from '../../services/state.service';
import { CountryService } from '../../services/country.service';
import { Subscription } from 'rxjs';
import { Globals } from '../../globals';

@Component({
		selector: 'app-display-address',
		templateUrl: './display-address.component.html',
		styleUrls: ['./display-address.component.css', '../../app.component.css']
})

export class DisplayAddressComponent implements OnInit {

	parent: string;
  customerOrSupplier: string;

	address: any = [];

	id: string;

	subs: Subscription[] = [];

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private addressService: AddressService,
		private stateService: StateService,
		private countryService: CountryService
	) {


    this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
		this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
    this.id = this.activatedRoute.snapshot.paramMap.get('id');

		this.subs[0] = this.addressService.getAddress(this.id).subscribe(addressObj => {
			this.address = {
				stateName: Globals.STATES[addressObj.stateId].name,
				countryName: Globals.COUNTRIES[addressObj.countryId].name,
				...addressObj
			}
		});
	}

	ngOnInit() {

	}
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/addresses']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/addresses']);
		}
	}

}
